export default "__VITE_ASSET__cb324d04__"